import React, { useState } from "react";
import "./style.scss";
import AuthFrame from "../../../components/Auth/AuthFrame";
import ResetPasswordForm from "../../../components/Auth/ResetPasswordForm";

const ResetPassword = () => {
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  return (
    <div className="signin-container">
      {/* <ErrorModal/> */}
      <div className="signin-left-wrapper">
        <div className="signin-left-form">
          <ResetPasswordForm />
        </div>
      </div>
      <div className="signin-right-wrapper">
        <div className="signin-right-authframe">
          <AuthFrame />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
